import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { ModelGenerationCreateView } from "./create/model-generation-create.view";
import { ModelGenerationView } from "./model-generation.view";
import { ModelGenerationUpdateView } from "./update/model-generation-update.view";

export function ModelGenerationRoutes() {
  const ability = useAbility();
  const modelGenerationUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "ModelGeneration");

  return (
    <Switch>
      <Route path="/" component={ModelGenerationView} />
      <Route path="/create" component={canManage ? ModelGenerationCreateView : ReadOnlyRedirect} />
      <Route path={modelGenerationUuidRegex} component={canManage ? ModelGenerationUpdateView : ReadOnlyRedirect} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
